import { ThemeProvider } from "next-themes";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SWRConfig } from "swr";
import { AuthProvider } from "@/auth/auth-provider";
import { PageLoader } from "@/components/status";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AdminLayout, AuthLayout } from "@/layouts/admin-layout";
import { apiFetch } from "@/lib/api-client";
import { ProtectedRoute, PublicRoute } from "@/routes/guards";
import { pages } from "@/routes/pages";

export function App() {
	return (
		<ThemeProvider
			attribute="class"
			storageKey="gridcast:theme"
			defaultTheme="system"
			enableSystem
			disableTransitionOnChange
			scriptProps={{ type: "application/json" }}
		>
			<SWRConfig
				value={{
					fetcher: (key: string) => apiFetch(key),
					revalidateOnFocus: false,
					shouldRetryOnError: false,
					keepPreviousData: true,
				}}
			>
				<BrowserRouter>
					<AuthProvider>
						<TooltipProvider>
							<Suspense fallback={<PageLoader />}>
								<Routes>
									<Route element={<PublicRoute />}>
										<Route element={<AuthLayout />}>
											<Route path="/login" element={<pages.login />} />
										</Route>
									</Route>
									<Route element={<ProtectedRoute />}>
										<Route element={<AdminLayout />}>
											<Route index element={<pages.overview />} />
											<Route path="tenants" element={<pages.tenants />} />
											<Route path="tenants/:tenantId" element={<pages.tenant />} />
											<Route path="users" element={<pages.users />} />
											<Route path="users/:userId" element={<pages.user />} />
											<Route path="admins" element={<pages.admins />} />
											<Route path="catalog" element={<pages.catalog />} />
											<Route path="payments" element={<pages.payments />} />
											<Route path="audit" element={<pages.audit />} />
											<Route path="*" element={<pages.notFound />} />
										</Route>
									</Route>
								</Routes>
							</Suspense>
						</TooltipProvider>
						<Toaster />
					</AuthProvider>
				</BrowserRouter>
			</SWRConfig>
		</ThemeProvider>
	);
}
